<template>
  <van-overlay class-name="reload-overlay" :show="visible">
    <div class="reload-page">
      <img src="~/assets/image/offline.png" />
      <p>你好像處於離線狀態</p>
      <p>請前往“設定”，檢查網路連接</p>
      <button @click="reload()">重试</button>
    </div>
  </van-overlay>
</template>
<script>
export default {
  name: 'Reload',
  components: {},
  props: {},
  data() {
    return {
      visible: true
    };
  },
  watch: {},
  computed: {},
  methods: {
    show() {
      this.show = true;
    },
    reload() {
      location.reload();
    }
  }
};
</script>
<style lang="scss" scoped>
.reload-overlay {
    background-color: white;
    z-index: 10;
}
.reload-page {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 32px;
  padding-top: 300px;
  color: #888;
  img {
    width: 180px;
    height: auto;
  }
  p {
    margin-top: 60px;
  }
  button {
    border: 1px solid #b2b2b2;
    padding: 20px 0;
    margin-top: 80px;
    width: 200px;
    border-radius: 10px;
  }
}
</style>
